import { forwardRef, type HTMLAttributes } from 'react'
import { cx } from './cx'
import s from './Surface.module.css'

export type SurfacePadding = 'none' | 'compact' | 'comfortable' | 'spacious'

export interface SurfaceProps extends HTMLAttributes<HTMLDivElement> {
  inset?: boolean
  /**
   * Content rhythm defaults to the shared comfortable inset. Grids, media and
   * other genuinely full-bleed content opt out explicitly with `none`.
   */
  padding?: SurfacePadding
}

export const Surface = forwardRef<HTMLDivElement, SurfaceProps>(function Surface(
  { inset, padding, className, ...rest },
  ref,
) {
  const resolvedPadding = padding ?? 'comfortable'
  return (
    <div
      ref={ref}
      className={cx(
        s.surface,
        inset && s.inset,
        padding == null && s.padDefault,
        padding === 'none' && s.padNone,
        padding === 'compact' && s.padCompact,
        padding === 'comfortable' && s.padComfortable,
        padding === 'spacious' && s.padSpacious,
        className,
      )}
      data-surface-padding={resolvedPadding}
      {...rest}
    />
  )
})
